// 单独请求文件
import axios from 'axios'
import QS from 'qs';

axios.interceptors.request.use(
  config => {
    if (window.localStorage.token) {
      config.headers['token'] = window.localStorage.token //访问全局变量下的token值
      // config.headers['Content-Type'] =  'application/json'

    }
    return config
  }, error => {
    //// console.log(error)
    Promise.reject(error)
  }
)

export function post(url, params) {
  return new Promise((resolve, reject) => {

    axios.post(url, QS.stringify(params))
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data)
      })
  });
}



// WEBPACK FOOTER //
// ./src/utils/api/router.js